<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <label class="col-md-12 form-control-label" [for]="control.key" style="font-weight:bold">{{control.value}}</label>
</div>